import React from 'react';
import { Link } from 'react-router-dom';

const AnnouncementBar = ({ settings }) => {
    const { text, link, backgroundColor = '#000000', textColor = '#ffffff' } = settings;

    if (!text) return null;

    const Content = () => (
        <div 
            className="py-2.5 px-4 text-center text-sm font-medium transition-opacity hover:opacity-90"
            style={{ backgroundColor, color: textColor }}
        >
            {text}
        </div>
    );

    if (link) {
        return (
            <Link to={link} className="block w-full">
                <Content />
            </Link>
        );
    }

    return <Content />;
};

export default AnnouncementBar;
